import "./DashboardChatSection.scss";
import React from "react";
import {Grid} from "@mui/material";
import ChatStore from "../../../../pages/chat-agent/ChatStore.ts";
import {ChatInput} from "../../../../pages/chat-agent/components/ChatInput/ChatInput";
import {observer} from "mobx-react-lite";
import {generatePath, useNavigate, useParams} from "react-router";
import {routes} from "../../../../routing/routes.ts";
import {useChatContext} from "../../../../pages/chat-agent/context/ChatContext.tsx";
import {useStores} from "../../../../stores";

export const DashboardChatSection: React.FC = observer(() => {
    const {bagStore} = useStores();
    const {startNewChat, isWaiting} = useChatContext();
    const navigate = useNavigate();
    const params = useParams();

    const handleSubmit = async (value: string) => {
        const trimmedValue = value.trim();
        const bagId = bagStore.bagId;
        if (!trimmedValue || !bagId) {
            return;
        }
        ChatStore.setUserInputValue(trimmedValue);
        if (isWaiting) {
            ChatStore.setUserInputValue(trimmedValue);
        } else {
            startNewChat(trimmedValue, bagId);
            ChatStore.setUserInputValue("");
        }
        navigate(generatePath(routes.chat, params));
    };

    return (
        <Grid
            component="section"
            container
            justifyContent="center"
            className="dashboard-chat-section"
        >
            <Grid size={{xl: 8, lg: 9, md: 12}}>
                <div className="dashboard-chat-input-wrap">
                    <ChatInput
                        conversationStarted={false}
                        defaultPosition="start"
                        disabled={!bagStore.bagId}
                        newChatDraftOnly
                        showChatSwitchLoading={false}
                        onSubmit={handleSubmit}
                    />
                </div>
            </Grid>
        </Grid>
    );
});